import { IApplicationState } from '../../types/redux';

export function getDeveloperDescription(state: IApplicationState) {
  return state.developer.description;
}
